@if (visible() && loadedData(); as _data) {
  <div class="grote-storing-banner__wrapper">
    <div class="container">
      <div class="grote-storing-banner" [class]="'grote-storing-banner--' + color()">
        <div class="grote-storing-banner__content">
          <div class="grote-storing-banner__title">{{ _data.title }}</div>
          <div class="grote-storing-banner__text">{{ _data.text }}</div>
          <div>
            {{ "GroteStoringBanner.LinkText" | translate }}
            <a class="grote-storing-banner__link" [href]="_data.baseURL" target="_blank" rel="noopener noreferrer"
              >grotestoring.nl</a
            >.
          </div>
        </div>
      </div>
    </div>
  </div>
}
